function makeDraggable(elmnt: any) {
    var pos1 = 0, pos2 = 0, pos3 = 0, pos4 = 0;
    let minY: number = 0;
    // let minX: number = 0;
    let maxY: number = window.innerHeight;
    let maxX: number = window.innerWidth;
    if (document.getElementById(elmnt.id + "-draggable")) {
        // if present, the header is where you move the DIV from:
        //@ts-ignore
        document.getElementById(elmnt.id + "-draggable").onmousedown = dragMouseDown;
    } else if(document.getElementById("draggable-section")){
        // @ts-ignore
        document.getElementById("draggable-section").onmousedown = dragMouseDown;
    }
    else {
        // otherwise, move the DIV from anywhere inside the DIV:
        elmnt.onmousedown = dragMouseDown;
    }

    function dragMouseDown(e: any) {
        e = e || window.event;
        e.preventDefault();
        // get the mouse cursor position at startup:
        pos3 = e.clientX;
        pos4 = e.clientY;
        document.onmouseup = closeDragElement;
        // call a function whenever the cursor moves:
        document.onmousemove = elementDrag;
    }

    function elementDrag(e: any) {
        e = e || window.event;
        e.preventDefault();
        // calculate the new cursor position:
        pos1 = pos3 - e.clientX;
        pos2 = pos4 - e.clientY;
        pos3 = e.clientX;
        pos4 = e.clientY;
        // set the element's new position:
        let topSpacing: number = elmnt.offsetTop - pos2;
        let leftSpacing: number = elmnt.offsetLeft - pos1;
        console.group("Element Drag Spacing");
        //console.log("Top Spacing: ", topSpacing);
        //console.log("Left Spacing: ", leftSpacing);
        //console.log("Positions: ", pos1, pos2, pos3, pos4);
        //console.log("Dimensions", )
        console.groupEnd();
        if(topSpacing + e.clientY < minY) {
            topSpacing = minY;
            pos1 = minY;
            pos4 = minY;
        }else if(topSpacing + elmnt.offsetHeight > maxY) {
            let maxTopSpacing: number = maxY - elmnt.offsetHeight;
            topSpacing = maxTopSpacing;
            pos1 = maxTopSpacing;
            pos4 = maxTopSpacing;
        }
        if(leftSpacing + elmnt.offsetWidth > maxX) {
            let maxLeftSpacing: number = maxX - elmnt.offsetWidth;
            leftSpacing = maxLeftSpacing;
            pos2 = maxLeftSpacing;
            pos3 = maxLeftSpacing;
        }
        elmnt.style.top = (topSpacing) + "px";
        elmnt.style.left = (leftSpacing) + "px";
    }

    function closeDragElement() {
        // stop moving when mouse button is released:
        document.onmouseup = null;
        document.onmousemove = null;
    }
}
interface DraggableConfig {
    /** An HTML Element or a string to feed to a querySelector */
    wrapper?: HTMLElement | string;
}
//? offsetHeight = full height of element including padding and borders
//? clientHeight = full height excluding border
//? let style = getComputedStyle(element) get full style of element
//? Get Margin = parseInt(style.marginTop)
export function makeDraggable2(elmnt: any, customConfig: DraggableConfig) {
    let config: any = {};
    if(customConfig) {
        config = {...customConfig};
        if(!config.wrapper){
            config.wrapper = document.body;
        }
    }else{ //? Creates default config
        config = {
            wrapper: document.body,
        }
    }
    // const wrapperStyles: any = getComputedStyle(config.wrapper);
    var pos1 = 0, pos2 = 0, pos3 = 0, pos4 = 0;
    let minY: number = 0;
    // let minX: number = 0;
    let maxY: number = config.wrapper?.innerHeight;
    // let maxX: number = config.wrapper?.innerWidth;
    if (document.getElementById(elmnt.id + "-draggable")) {
        // if present, the header is where you move the DIV from:
        //@ts-ignore
        document.getElementById(elmnt.id + "-draggable").onmousedown = dragMouseDown;
    } else {
        // otherwise, move the DIV from anywhere inside the DIV:
        elmnt.onmousedown = dragMouseDown;
    }

    function dragMouseDown(e: any) {
        e = e || window.event;
        e.preventDefault();
        // get the mouse cursor position at startup:
        pos3 = e.clientX;
        pos4 = e.clientY;
        document.onmouseup = closeDragElement;
        // call a function whenever the cursor moves:
        document.onmousemove = elementDrag;
    }

    function elementDrag(e: any) {
        e = e || window.event;
        e.preventDefault();
        // calculate the new cursor position:
        pos1 = pos3 - e.clientX;
        pos2 = pos4 - e.clientY;
        pos3 = e.clientX;
        pos4 = e.clientY;
        // set the element's new position:
        let topSpacing: number = elmnt.offsetTop - pos2;
        let leftSpacing: number = elmnt.offsetLeft - pos1;
        console.group("Element Drag Spacing");
        //console.log("Top Spacing: ", topSpacing);
        //console.log("Left Spacing: ", leftSpacing);
        //console.log("Positions: ", pos1, pos2, pos3, pos4);
        //console.log("Dimensions", )
        console.groupEnd();
        if(topSpacing + e.clientY < minY) {
            topSpacing = minY;
            pos1 = minY;
            pos4 = minY;
        }else if(topSpacing + elmnt.offsetHeight > maxY) {
            let maxTopSpacing: number = maxY - elmnt.offsetHeight;
            topSpacing = maxTopSpacing;
            pos1 = maxTopSpacing;
            pos4 = maxTopSpacing;
        }
        elmnt.style.top = (topSpacing) + "px";
        elmnt.style.left = (leftSpacing) + "px";
    }

    function closeDragElement() {
        // stop moving when mouse button is released:
        document.onmouseup = null;
        document.onmousemove = null;
    }
}
// function makeDraggable(containerId: string, draggableId: string = "") {
//     let container: HTMLElement = document.getElementById(containerId) as HTMLElement;
//     let draggableElement: HTMLElement = document.getElementById(draggableId) as HTMLElement;
//     let elmnt: HTMLElement = draggableElement || container;
//     var pos1 = 0, pos2 = 0, pos3 = 0, pos4 = 0;
//     function elementDrag(e: MouseEvent){
//         e = e || window.event;
//         e.preventDefault();
//         // calculate the new cursor position:
//         pos1 = pos3 - e.clientX;
//         pos2 = pos4 - e.clientY;
//         pos3 = e.clientX;
//         pos4 = e.clientY;
//         // set the element's new position:
//         elmnt.style.top = (elmnt.offsetTop - pos2) + "px";
//         elmnt.style.left = (elmnt.offsetLeft - pos1) + "px";
//     }
//     function closeDragElement(){
//         // stop moving when mouse button is released:
//         document.onmouseup = null;
//         document.onmousemove = null;
//     }  
//     function dragMouseDown(e: MouseEvent){
//         e = e || window.event;
//         e.preventDefault();
//         // get the mouse cursor position at startup:
//         pos3 = e.clientX;
//         pos4 = e.clientY;
//         document.onmouseup = closeDragElement;
//         // call a function whenever the cursor moves:
//         document.onmousemove = elementDrag;
//     }
//     if (draggableElement) {
//         // if present, the draggable element is where you move the DIV from:
//         draggableElement.onmousedown = dragMouseDown;
//     } else {
//       // otherwise, move the DIV from anywhere inside the DIV:
//         container.onmousedown = dragMouseDown;
//     }
// }

export default makeDraggable;